import GraphContent from "../graph_content";
import axios from "axios";
import { RequestParamsMaker } from "./make_request_params";
import { i18n } from "@/main";

/**
 * 入力データチェック処理
 * @param self グラフコンテンツ
 */
const validation = (self: GraphContent) => {
  // パーティションキーの入力チェック
  if (self.downloadCsvPartitionKey === "") {
    // 変数入りのメッセージが文法上おかしくないようif分岐
    if (i18n.locale === "ja") {
      return self.partitionKey + self.$t("message.choose");
    } else {
      return self.$t("message.choose") + self.partitionKey;
    }
  }
  // ダウンロード対象範囲指定の入力チェック
  if (
    self.downloadCsvFromDate === "" ||
    (self.downloadCsvPeriodType === "between" && self.downloadCsvToDate === "")
  ) {
    return self.$t("message.enterTargetPeriod");
  }
  // 最後まで進むとチェックOK
  return true;
};

/**
 * CSVダウンロード処理
 * @param self グラフコンテンツ
 */
export async function downloadCsv(self: GraphContent) {
  try {
    // 入力内容のチェック
    const validationError = validation(self);
    if (typeof validationError === "string") {
      alert(validationError);
      return;
    }
    self.downloadingCsv = true;
    // リクエスト情報の生成
    const requestParams = RequestParamsMaker.makeDownloadCsvParams(self);
    console.log(JSON.stringify(requestParams.data));
    // CSVダウンロードAPIの実行
    const apiResponse = await axios(requestParams);

    // レスポンスを受けての処理
    if (apiResponse.status === 200) {
      // データ件数を取得
      const count = apiResponse.data.count;
      if (count === 0) {
        alert(self.$t("message.thereIsNoDataWithinTargetPeriod"));
      } else {
        if (count > 100000) {
          alert(self.$t("message.unableToGetAllData") + count.toLocaleString() + self.$t("message.recordsWillBeDownloaded"));
        } else {
          alert(count.toLocaleString() + self.$t("message.recordsWillBeDownloaded"));
        }
        // レスポンスからCSVデータを取得
        const csv = apiResponse.data.csv;
        // データが存在する場合のみダウンロード実行
        const blob = new Blob([csv], { type: "text/csv" });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "Result.csv";
        link.click();
      }
    } else if (apiResponse.status === 210) {
      alert(self.$t("message.dataSizeExceeds5MBLimitPlsChange"));
    } else {
      alert(self.$t("message.failedToDownload"));
    }
    self.downloadingCsv = false;
    return;
  } catch (e) {
    console.error(e);
    alert(self.$t("message.failedToDownload"));
    self.downloadingCsv = false;
    return;
  }
}
